
import { RootState } from "@/store/types";

import { INFORMATION_STORE as S, InformationState, ChampLibreVO } from "./types";
import { ActionTree, Action } from "vuex";
import { Individu } from '@/models/Individu';
import db from "@/db";

export const fetchInformations: Action<
  InformationState,
  RootState
> = ({ getters, dispatch, rootGetters }) => {
  return new Promise(async (resolve, reject) => {
    let individu: Individu = rootGetters.getIndividu;
    dispatch("fetchParents", individu);
    if (rootGetters.getCurrentUser.infosanitaire)
      dispatch("fetchInformationsSanitaires", individu);
    if (rootGetters.getCurrentUser.clfamille)
      dispatch("fetchChampsLibresFamille", individu);
    if (rootGetters.getCurrentUser.clindividu)
      dispatch("fetchChampsLibresIndividu", individu);

    resolve('fetchInformations done');
  })
}
export const fetchChampsLibresFamille: Action<
  InformationState,
  RootState
> = ({ commit }, individu: Individu) => {
  return new Promise((resolve, reject) => {
    commit(S.SET_FAMILLE_CHAMPS, individu.getListeChampsFamilles())
    commit(S.SET_CHAMPS_LIBRES, individu.getChampsLibres())
    commit(S.SET_CHAMPS_LIBRES_VALEURS, individu.getChampLibreValeur())
    commit(S.SET_CHAMPS_LIBRES_RESULTS_VALEURS, individu.getChampLibreResultValeur())
    resolve('fetchChampsLibres done');
  })
}
export const fetchChampsLibresIndividu: Action<
  InformationState,
  RootState
> = ({ commit }, individu: Individu) => {
  return new Promise((resolve, reject) => {
    commit(S.SET_INDIVIDU_CHAMPS, individu.getListeChampsIndividu())
    commit(S.SET_CHAMPS_LIBRES, individu.getChampsLibres())
    commit(S.SET_CHAMPS_LIBRES_VALEURS, individu.getChampLibreValeur())
    commit(S.SET_CHAMPS_LIBRES_RESULTS_VALEURS, individu.getChampLibreResultValeur())
    resolve('fetchChampsLibres done');
  })
}

export const fetchInformationsSanitaires: Action<
  InformationState,
  RootState
> = ({ commit, rootGetters }, individu: Individu) => {
  return new Promise((resolve, reject) => {
    if (typeof individu.getMedecin_id() !== 'undefined' && Number.isInteger(individu.getMedecin_id()))
      commit(S.SET_MEDECIN, individu.getMedecin());
    commit(S.SET_MALADIES, individu.getListeMaladies());
    commit(S.SET_ALLERGIES, individu.getListeAllgeries());
    commit(S.SET_VACCINS, individu.getListeVaccins());
    commit(S.SET_INFORMATION_INDIVIDU, individu.getInformationIndividu());
    resolve('InfoSanitaires done')
  })
}
export const fetchDossier: Action<
  InformationState,
  RootState
> = ({ commit }) => {
  return new Promise((resolve, reject) => {

    commit(S.SET_DOSSIER, db.findDossier());
    resolve("fetchDossier done");
  })
}

export const fetchParents: Action<
  InformationState,
  RootState
> = ({ commit, rootGetters }, individu) => {
  return new Promise((resolve, reject) => {
    commit(S.SET_PARENTS, individu.getListeParents())
    resolve("done");
  })
}

export const actions: ActionTree<InformationState, RootState> = {
  fetchInformations,
  fetchDossier,
  fetchParents,
  fetchChampsLibresIndividu,
  fetchChampsLibresFamille,
  fetchInformationsSanitaires,
};
